import {useEffect, useRef} from 'react';

import {Button} from 'primereact/button';
import {Menu} from 'primereact/menu';

import {TokenService} from '../../../../he-thong/chung-thu-so/TokenService';
import {ToastService} from '../../../../../AppToast';

import {Sign} from '../../../../../shared/component/Sign';

import {useCellEditing} from '../../../../../shared/hooks/CellEditing';

import {Crup} from '../../../../he-thong/chung-thu-so/component/crup';
import {CreateFileCa} from '../../../../he-thong/chung-thu-so/component/createFileCa';
import {CreateEASYCA} from '../../../../he-thong/chung-thu-so/component/createEASYCA';
import {CreateNCCA} from '../../../../he-thong/chung-thu-so/component/createNCCA';
import {CreateICA} from '../../../../he-thong/chung-thu-so/component/createICA';
import {CreateIntrustCA} from '../../../../he-thong/chung-thu-so/component/createIntrustCA';

export const TokenElement = ({tokens, setTokens, reloadTokens}) => {

  const header = 'Đăng ký chứng thư số';
  const dataKey = 'id';

  const menu = useRef(null);

  const crup = Crup({header, dataKey, refreshLazyData: reloadTokens});

  const createFileCa = CreateFileCa({header, dataKey, refreshLazyData: reloadTokens});

  const createEASYCA = CreateEASYCA({header, dataKey, refreshLazyData: reloadTokens});

  const createNCCA = CreateNCCA({header, dataKey, refreshLazyData: reloadTokens});

  const createICA = CreateICA({header, dataKey, refreshLazyData: reloadTokens});
  const createIntrustCA = CreateIntrustCA({header, dataKey, refreshLazyData: reloadTokens});

  const createToken = () => {
    Sign({
      "CommandName": "TokenInfo"
    }).then((data) => {
      if (data && data.data && data.data.token) {
        const {token} = data.data;

        crup.create();

        crup.setValue({
          vender: token.Issuer,
          serialNumber: token.SerialNumber,
          subjectName: token.Subject,
          dateFrom: new Date(token.NotBefore),
          expireDate: new Date(token.NotAfter),
          form: 1,
          tokenType: 0,
          used: true
        });
      } else {
        ToastService.error('Dữ liệu không hợp lệ');
      }
    });
  }

  const menus = [
    {label: 'USB token', command: createToken},
    {label: 'FILE CA', command: createFileCa.open},
    {label: 'Service EASYCA', command: createEASYCA.open},
    {label: 'Service NCCA', command: createNCCA.open},
    {label: 'Service I-CA', command: createICA.open},
    {label: 'Service Intrust-CA', command: createIntrustCA.open}
  ];

  useEffect(() => {
    TokenService.getList({Used: true, MaxResultCount: 1000}).then(({items}) => {
      items.forEach(item => {
        if (item.dateFrom) {
          item.dateFrom = new Date(item.dateFrom);
        }
        if (item.expireDate) {
          item.expireDate = new Date(item.expireDate);
        }
        item.vender = item.vender || '';
        item.form = item.form || 1;
      });
      setTokens(items);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const {render: renderEditing, selectedItem: editingItem, setSelectedItem: setEditingItem} = useCellEditing({
    dataKey: 'id',
    columns: [
      {
        field: 'index', header: 'STT', style: {textAlign: 'center'}, dataType: 'custom', customCell(rowData: any, rowIndex): any {
          return rowIndex + 1;
        }
      },
      {field: 'vender', header: 'Tên tổ chức cơ quan chứng thực/cấp/công nhận chữ ký số, chữ ký điện tử', style: {minWidth: '160px', maxWidth: '160px'}},
      {field: 'serialNumber', header: 'Số sê-ri chứng thư', style: {minWidth: '170px'}},
      {field: 'dateFrom', header: 'Từ ngày', editable: false, dataType: 'date', style: {minWidth: '100px', maxWidth: '100px'}},
      {field: 'expireDate', header: 'Đến ngày', editable: false, dataType: 'date', style: {minWidth: '100px', maxWidth: '100px'}},
      {
        field: 'form', header: 'Hình thức đăng ký', dataType: 'dropdown', editable: true, inputProps: {options: TokenService.forms}, style: {minWidth: '170px'}
      }
    ],
    items: tokens,
    onCellChange: (rowData, column, newValue) => {
      const _tokens = [...tokens];
      for (const _item of _tokens) {
        if (_item.id === rowData.id) {
          _item[column.field] = newValue;
        }
      }
      setTokens(_tokens);
    }
  });

  // const addToken = () => {
  //   Sign({
  //     "CommandName": "TokenInfo"
  //   }).then((data) => {
  //     console.log(data);
  //     if (data && data.data && data.data.token) {
  //       const {token} = data.data;
  //       const _tokens = [...tokens];
  //       _tokens.push({
  //         vender: token.Issuer,
  //         serialNumber: token.SerialNumber,
  //         subjectName: token.Subject,
  //         dateFrom: new Date(token.NotBefore),
  //         expireDate: new Date(token.NotAfter),
  //         form: 1,
  //         tokenType: 0
  //       });
  //       setTokens(_tokens);
  //     } else {
  //       ToastService.error('Dữ liệu không hợp lệ');
  //     }
  //   });
  // }

  const deleteToken = () => {
    if (editingItem) {
      const _tokens = tokens.filter((f) => f.id !== editingItem.id);
      setTokens(_tokens);
      setEditingItem(null);
    }
  }

  return (
    <div className="grid">
      <div className="mb-1 col-12 un-fluid">
        <Menu model={menus} popup ref={menu}/>
        <Button label="Thêm" className="p-button-outlined p-button-success p-button-sm mr-2" onClick={(event) => menu.current.toggle(event)}/>
        <Button label="Xoá" className="p-button-outlined p-button-danger p-button-sm" onClick={deleteToken} disabled={!editingItem}/>
      </div>
      <div className="col-12">
        {renderEditing()}
      </div>

      {crup.render()}
      {createFileCa.render()}
      {createEASYCA.render()}
      {createNCCA.render()}
      {createICA.render()}
      {createIntrustCA.render()}
    </div>
  );
}